const WORKER_URL = import.meta.env['VITE_WORKER_URL'] ?? 'http://localhost:8787';
let initData = '';
export function setInitData(v) {
    initData = v;
}
export async function api(path, init = {}) {
    const res = await fetch(`${WORKER_URL}${path}`, {
        ...init,
        headers: {
            'Content-Type': 'application/json',
            'X-Init-Data': initData,
            ...(init.headers ?? {}),
        },
    });
    if (!res.ok) {
        const body = (await res.json().catch(() => ({})));
        throw new Error(body.error ?? `HTTP ${res.status}`);
    }
    return (await res.json());
}
